// extracted by mini-css-extract-plugin
module.exports = {"selected":"prompt_selected__3UzG8","not-selected":"prompt_not-selected__4dig8","promptButton":"prompt_promptButton__2KBES"};